// EmployeeForm.tsx
import React from "react";

import { BusinessEmployeeFormUI } from "0.Mine/0.Components/BusinessCard/Employee/UI/BusinessEmployees";
import { Employee } from "0.Mine/3.Interfaces/Employee";
import { BusinessService } from "0.Mine/3.Interfaces/Services";

import { useEmployeeFormLogicOnboarding } from "../../Logic/Employees/EmployeeForm";

export interface EmployeeFormProps {
  initialValue: Employee[];
  updateBusinessData: (data: Employee[]) => void;
  services: BusinessService[];
}

const EmployeeForm: React.FC<EmployeeFormProps> = ({
  initialValue,
  updateBusinessData,
  services,
}) => {
  const {
    employees,
    showAddForm,
    handleAddEmployee,
    handleUpdateEmployee,
    handleDeleteEmployee,
    toggleAddForm,
    onFileUpload,
  } = useEmployeeFormLogicOnboarding(initialValue, updateBusinessData);

  return (
    <BusinessEmployeeFormUI
      ALL_AVAILABLE_SERVICES={services}
      employees={employees}
      showAddForm={showAddForm}
      toggleAddForm={toggleAddForm}
      handleAddEmployee={handleAddEmployee}
      handleUpdateEmployee={handleUpdateEmployee}
      handleDeleteEmployee={handleDeleteEmployee}
      onFileUpload={onFileUpload}
    />
  );
};

export default EmployeeForm;
